import React, { PropTypes } from 'react/addons';
import shallowEqual from 'react/lib/shallowEqual';

import moment from 'ofs/moment';
import createRange from 'ofs/utils/range';
import datesAreSame from 'ofs/utils/datesAreSame';

import Month from './Month';
import Arrow from './Arrow';
import DayHeaders from './DayHeaders';
import DateComponent from './DateComponent';

const lang = moment().localeData();

function previousMonth(date) {
  if (date.getMonth() === 0) {
    // return previous year
    return new Date(date.getFullYear() - 1, 11, 1);
  }
  return new Date(date.getFullYear(), date.getMonth() - 1, 1);
}

function nextMonth(date) {
  if (date.getMonth() === 11) {
    // return next year
    return new Date(date.getFullYear() + 1, 0, 1);
  }
  return new Date(date.getFullYear(), date.getMonth() + 1, 1);
}

function isWeekend(date) {
  if (date.getDay() === 0 || date.getDay() === 6) {
    return true;
  }
  return false;
}

const Calendar = React.createClass({
  propTypes: {
    minimumDate: PropTypes.instanceOf(Date),
    weekStarts: PropTypes.number,
    initialDate: PropTypes.instanceOf(Date), // initial date to view

    value: PropTypes.instanceOf(Date),
    onSelect: PropTypes.func,

    isSelected: PropTypes.func, // override is selected logic
    renderDate: PropTypes.func, // override date render
  },

  shouldComponentUpdate(nextProps, nextState) {
    return !shallowEqual(this.props, nextProps) ||
           !shallowEqual(this.state, nextState);
  },

  getDefaultProps() {
    return {
      weekStarts: 1, // Monday
      onSelect: () => {},
    };
  },

  getValue() {
    return this.props.value ? this.props.value : this.props.initialDate;
  },

  getInitialState() {
    const value = this.getValue();
    const today = new Date();

    return {
      dateView: value ? value : today,
    };
  },

  isSelectable(date) {
    const { minimumDate } = this.props;
    minimumDate.setHours(0, 0, 0, 0);

    if (minimumDate && date < minimumDate) {
      return false;
    }
    return true;
  },

  isSelected(date) {
    const { value, isSelected } = this.props;

    if (typeof isSelected === 'function') {
      return isSelected(date);
    }

    if (value && datesAreSame(value, date)) {
      return true;
    }
    return false;
  },

  canMoveBackwards() {
    const { minimumDate } = this.props;
    if (!minimumDate) {
      return true;
    }

    const { dateView } = this.state;
    const monthCheck = new Date(dateView.getTime());
    // set to the end of the previous month
    monthCheck.setDate(0);

    if (monthCheck < minimumDate) {
      return false;
    }

    return true;
  },

  canMoveForwards() {
    // TODO
    return true;
  },

  handlePreviousClick() {
    if (!this.canMoveBackwards()) {
      return false;
    }

    const { dateView } = this.state;
    const newMonth = previousMonth(dateView);

    this.setState({
      dateView: newMonth,
    });
  },

  handleNextClick() {
    if (!this.canMoveForwards()) {
      return false;
    }

    const { dateView } = this.state;
    const newMonth = nextMonth(dateView);

    this.setState({
      dateView: newMonth,
    });
  },

  handleMonthChange(event) {
    const { dateView } = this.state;
    const newMonth = new Date(dateView.getFullYear(), event.target.value, 1);

    this.setState({
      dateView: newMonth,
    });
  },

  handleYearChange(event) {
    const { dateView } = this.state;
    const newYear = new Date(event.target.value, dateView.getMonth(), 1);

    this.setState({
      dateView: newYear,
    });
  },

  renderDay(date) {
    const { onSelect, renderDate } = this.props;
    const { dateView } = this.state;

    const state = {
      enabled: this.isSelectable(date),
      selected: this.isSelected(date),
      notInMonth: date.getMonth() !== dateView.getMonth(),
      isWeekend: isWeekend(date),
    };

    if (typeof renderDate === 'function') {
      const dateComponent = renderDate(date, state);
      return React.cloneElement(dateComponent, {
        date,
        onClick: dateComponent.props.enabled && onSelect.bind(null, date),
      });
    }

    return (
      <DateComponent
        {...state}
        date={date}
        key={date.getTime()}
        onClick={state.enabled && onSelect.bind(null, date)}
      />
    );
  },

  renderHeaderMonth() {
    const { minimumDate } = this.props;
    const { dateView } = this.state;

    return (
      <span className="ofs-Calendar__MonthHeaderLabel">
        {lang._months[dateView.getMonth()]}
        <select className="ofs-Calendar__MonthHeaderSelect"
          value={dateView.getMonth()}
          onChange={this.handleMonthChange}
        >
          {createRange(0, 12).map((index) => (
            <option
              key={index}
              value={index}
              disabled={minimumDate && minimumDate.getFullYear() >= dateView.getFullYear() && index < minimumDate.getMonth()}
            >
              {lang._months[index]}
            </option>
          ))}
        </select>
      </span>
    );
  },

  renderHeaderYear() {
    const { minimumDate } = this.props;
    const { dateView } = this.state;
    const today = new Date();

    const currentYear = today.getFullYear();
    const yearList = createRange(currentYear - 5, currentYear)
      .concat(createRange(currentYear, currentYear + 10));

    return (
      <span className="ofs-Calendar__MonthHeaderLabel">
        {dateView.getFullYear()}
        <select
          className="ofs-Calendar__MonthHeaderSelect"
          value={dateView.getFullYear()}
          onChange={this.handleYearChange}
        >
          {yearList.map((year) => (
            <option
              key={year}
              value={year}
              disabled={minimumDate && year < minimumDate.getFullYear()}
            >
              {year}
            </option>
          ))}
        </select>
      </span>
    );
  },

  render() {
    const { weekStarts } = this.props;
    const { dateView } = this.state;

    return (
      <div className="ofs-Calendar">
        <Arrow direction="previous" disabled={!this.canMoveBackwards()} onClick={this.handlePreviousClick} />

        <div className="ofs-Calendar__MonthHeader">
          {this.renderHeaderMonth()} {this.renderHeaderYear()}
        </div>

        <div className="ofs-Calendar__MonthWrapper">
          <table className="ofs-Calendar__Month">
            <DayHeaders weekStarts={weekStarts}>
              {(dayIndex) => (
                <abbr title={lang._weekdays[dayIndex]}>{lang._weekdaysShort[dayIndex]}</abbr>
              )}
            </DayHeaders>

            <Month dateView={dateView} weekStarts={weekStarts}>
              {this.renderDay}
            </Month>
          </table>
        </div>
        <Arrow direction="next" disabled={!this.canMoveForwards()} onClick={this.handleNextClick} />
      </div>
    );
  }
});

export default Calendar;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/Calendar/Calendar.jsx
 **/